var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { x } from '@imtbl/sdk';
import PQueue from 'p-queue';
import { useCallback, useEffect, useState } from 'react';
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { CurrencyTokenSymbol, imxAddressL1AddressMap } from '../../data/currency-tokens/currency-tokens';
import { appEnv } from '../../env';
var symbolCoingeckoMap = {
    USDC: 'usd-coin',
    ETH: 'ethereum',
    IMX: 'immutable-x',
};
var COINGECKO_API_URL = 'https://api.coingecko.com/api/v3/simple/price?ids=immutable-x%2Cethereum%2Cgods-unchained%2Cguild-of-guardians%2Cusd-coin%2Cecomi%2Capecoin&vs_currencies=usd';
var RATE_LIMIT_INTERVAL = 1000;
var RATE_LIMIT_CAP_PUBLIC = 5 - 1;
var LS_LAST_CURRENCY_CONVERSION_KEY = 'last-currency-conversion';
export function useCurrencyContext() {
    var _this = this;
    var _a = useState(undefined), tokens = _a[0], setTokens = _a[1];
    var imxClient = useState(new x.IMXClient(x.imxClientConfig({ environment: appEnv.blockchain.imxConfig })))[0];
    var queue = useState(getInitializedQueue())[0];
    var _b = useState(0), ctaTokenUsdRate = _b[0], setCtaTokenUsdRate = _b[1];
    var _c = useState(undefined), usdcAddress = _c[0], setUsdcAddress = _c[1];
    var getCtaTokenUsdRate = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var rates_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, gqlSdk.CtaTokenGetRates()];
                case 1:
                    rates_1 = _a.sent();
                    setCtaTokenUsdRate(function (value) { var _a; return ((_a = rates_1.ctaTokenGetRates) === null || _a === void 0 ? void 0 : _a.usd) || value; });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var updateTokensAndPrices = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var response, newTokens, defaultToken, newSelectedToken, localStorageItem, localStorageData, previousDate, currentDate, tokenUsdValue, requested, resultedCtaTokenAddress, coingeckoResponse, _a, _loop_1, _i, _b, _c, symbol, coingeckoKey, data;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, imxClient.listTokens()];
                case 1:
                    response = _d.sent();
                    if (!response)
                        return [2 /*return*/];
                    newTokens = response.result.map(function (token) { return (__assign(__assign({}, token), { usdPrice: null })); });
                    defaultToken = response.result.find(function (token) { return token.symbol === CurrencyTokenSymbol.CTA; });
                    defaultToken = defaultToken || response.result[0];
                    newSelectedToken = defaultToken ? __assign(__assign({}, defaultToken), { usdPrice: null }) : null;
                    localStorageItem = localStorage.getItem(LS_LAST_CURRENCY_CONVERSION_KEY);
                    localStorageData = localStorageItem ? JSON.parse(localStorageItem) : undefined;
                    previousDate = localStorageData && localStorageData.date ? Number.parseInt(localStorageData.date) : undefined;
                    currentDate = Date.now();
                    tokenUsdValue = localStorageData === null || localStorageData === void 0 ? void 0 : localStorageData.tokenUsdValue;
                    requested = false;
                    resultedCtaTokenAddress = undefined;
                    if (!(!previousDate || (currentDate - previousDate) / 1000 > 60)) return [3 /*break*/, 6];
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(COINGECKO_API_URL)];
                case 3:
                    coingeckoResponse = _d.sent();
                    return [4 /*yield*/, coingeckoResponse.json()];
                case 4:
                    tokenUsdValue = _d.sent();
                    requested = true;
                    return [3 /*break*/, 6];
                case 5:
                    _a = _d.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (tokenUsdValue) {
                        _loop_1 = function (symbol, coingeckoKey) {
                            if (tokenUsdValue[coingeckoKey]) {
                                var token = newTokens.find(function (t) { return t.symbol === symbol; });
                                if ((token === null || token === void 0 ? void 0 : token.symbol) === CurrencyTokenSymbol.USDC) {
                                    resultedCtaTokenAddress = token.token_address;
                                }
                                if (token)
                                    token.usdPrice = tokenUsdValue[coingeckoKey].usd;
                                if (newSelectedToken && newSelectedToken.symbol === symbol)
                                    newSelectedToken.usdPrice = tokenUsdValue[coingeckoKey].usd;
                            }
                        };
                        for (_i = 0, _b = Object.entries(symbolCoingeckoMap); _i < _b.length; _i++) {
                            _c = _b[_i], symbol = _c[0], coingeckoKey = _c[1];
                            _loop_1(symbol, coingeckoKey);
                        }
                        data = { tokenUsdValue: tokenUsdValue, date: currentDate };
                        if (requested) {
                            localStorage.setItem(LS_LAST_CURRENCY_CONVERSION_KEY, JSON.stringify(data));
                        }
                    }
                    setTokens(newTokens.filter(function (token) { return Object.values(CurrencyTokenSymbol).includes(token.symbol); }));
                    setUsdcAddress(resultedCtaTokenAddress);
                    return [2 /*return*/];
            }
        });
    }); }, [imxClient]);
    useEffect(function () {
        updateTokensAndPrices();
        getCtaTokenUsdRate();
    }, [updateTokensAndPrices, getCtaTokenUsdRate]);
    function getInitializedQueue() {
        return new PQueue({
            interval: RATE_LIMIT_INTERVAL,
            intervalCap: RATE_LIMIT_CAP_PUBLIC,
            concurrency: RATE_LIMIT_CAP_PUBLIC,
        });
    }
    function parseCurrencyQuantity(quantity, tokenAddress) {
        var token = tokens === null || tokens === void 0 ? void 0 : tokens.find(function (t) { return t.token_address === tokenAddress || imxAddressL1AddressMap[t.token_address] === tokenAddress; });
        if (!token)
            return {};
        var decimals = Number.parseInt(token.decimals);
        var extendedPrice = quantity.padStart(decimals + 1, '0');
        var parsedPrice = "".concat(extendedPrice.slice(0, extendedPrice.length - decimals), ".").concat(extendedPrice.slice(-decimals));
        var base = {
            value: Number.parseFloat(parsedPrice),
            displayValue: Number.parseFloat(parsedPrice).toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 4,
                roundingMode: 'floor',
            }),
            symbol: token.symbol,
        };
        var usd = token.usdPrice
            ? {
                value: base.value * token.usdPrice,
                displayValue: (base.value * token.usdPrice).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
            }
            : undefined;
        if (tokenAddress === appEnv.ctaTokenAddress) {
            usd = {
                value: base.value * ctaTokenUsdRate,
                displayValue: (base.value * ctaTokenUsdRate).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
            };
        }
        return { address: tokenAddress, base: base, usd: usd };
    }
    function parseCurrencyQuantityNumber(quantity, tokenAddress) {
        var token = tokens === null || tokens === void 0 ? void 0 : tokens.find(function (t) { return t.token_address === tokenAddress; });
        if (!token)
            return {};
        var base = {
            value: quantity,
            displayValue: quantity.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 }),
            symbol: token.symbol,
        };
        var usd = token.usdPrice
            ? {
                value: base.value * token.usdPrice,
                displayValue: (base.value * token.usdPrice).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
                symbol: '$',
            }
            : undefined;
        if (tokenAddress === appEnv.ctaTokenAddress) {
            usd = {
                value: base.value * ctaTokenUsdRate,
                displayValue: (base.value * ctaTokenUsdRate).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
                symbol: '$',
            };
        }
        return { base: base, usd: usd };
    }
    return {
        imxClient: imxClient,
        tokens: tokens,
        queue: queue,
        ctaTokenUsdRate: ctaTokenUsdRate,
        usdcAddress: usdcAddress,
        parseCurrencyQuantity: parseCurrencyQuantity,
        parseCurrencyQuantityNumber: parseCurrencyQuantityNumber,
    };
}
